<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jdz6yG/tc-custom/9781625673404.jpg?1731883558450" alt="This image is the cover for the book Murder Is a Piece of Cake, Josie Marcus, Mystery Shopper"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Murder Is a Piece of Cake, Josie Marcus, Mystery Shopper
      </h1>
      <p class="bookDescription body article font2">
        <b>Before mystery shopper Josie Marcus can say “I do” she must solve a matrimonial murder to keep her in-law from becoming an inmate...</b><br/><br/>As a bride-to-be, Josie’s latest assignment is a gift—mystery shopping flower and cake vendors for a popular St. Louis wedding website. She even meets another bride, Molly Deaver, at the local florist. Turns out, Josie and Molly have a lot in common, including the groom! Molly has been stalking Dr. Ted for months, but after his high-maintenance mother, Lenore, confronts the faux fiancée, everyone believes Molly is history. Instead, she’s murdered and Ted’s pistol-packing mama is cuffed for the crime.<br/><br/>While it’s tempting to leave her future mother-in-law behind bars, Josie knows she and Ted can’t get married until Lenore is freed. It’s up to Josie and her amateur sleuthing skills to unwrap this case, clear Lenore’s name, and unveil the real killer…or her wedding bells could soon become death knells.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elaine Viets
      </h2>
      
      <p class="authorDescription body article">Elaine Viets has written 34 mysteries in four series: the bestselling Dead-End Job series with South Florida PI Helen Hawthorne, the cozy Josie Marcus Mystery Shopper mysteries, and the dark Francesca Vierling mysteries. With the Angela Richman Death Investigator series, Elaine returns to her hardboiled roots and uses her experience as a stroke survivor and her studies at the Medicolegal Death Investigators Training Course. Elaine was a director at large for the Mystery Writers of America. She's a frequent contributor to <I>Alfred Hitchcock's Mystery Magazine</I> and anthologies edited by Charlaine Harris and Lawrence Block. Elaine won the Anthony, Agatha and Lefty Awards.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      JABberwocky Literary Agency, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5b2a70f3